import { render, staticRenderFns } from "./plustagSvg.vue?vue&type=template&id=454b88c4&"
import script from "./plustagSvg.vue?vue&type=script&lang=js&"
export * from "./plustagSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports